import React from 'react'
import PropTypes from 'prop-types'
import {Provider} from 'react-redux'
import {Router} from 'react-router'
import IntlContainer from 'containers/IntlContainer'

export default class Root extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.element.isRequired,
    store: PropTypes.object.isRequired
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <IntlContainer>
          <div style={{height: '100%'}}>
            <Router history={this.props.history}>
              {this.props.routes}
            </Router>
          </div>
        </IntlContainer>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./client/containers/Root.js